module.exports = __webpack_public_path__ + "static/media/plavi-logo.4dc7cffb.png";